import React from "react";
import * as actions from '../actions';
import ShareOptions from "./ShareOptions";
export default function ReviewsData({ reviews, eleRef , isApp, userName}) {
    const items = [];

    var fooArray = Object.entries(reviews);
    var sublist = [];
    var count = 0;
    fooArray.forEach(([key, value]) => {
        if (value.starrating != 0) {
            for (var i = 0; i < 5; i++) {
                if (i < value.starrating) {
                    sublist.push(<div key={i} className="rec-star-img left">
                        <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/big-star.png" />
                    </div>);
                    // items.push(key=>i);
                } else {
                    sublist.push(<div key={i} className="rec-star-img left">
                        <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                    </div>
                    );
                    // items.push(key=>i);
                }

            }
            items[key] = sublist;
            sublist = [];
            // sublist=[];
            // count++;
        }
    });
    
    console.log(items);
    console.log(sublist);

    return (
        <div>
            {reviews && reviews.length > 0 && reviews.map((reviews, index) =>
                <div key={index} className="reviewBlock">
                    <div className="rec-user-block">
                        <div className="rec-user-img left">
                            {reviews.gender == "female" ?
                                <img src={reviews.userphoto.replace("http://", "https://")} onError={(e) => (e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/mother_profile.png")} /> :
                                <img src={reviews.userphoto.replace("http://", "https://")} onError={(e) => (e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/father_profile.png")} />
                            }
                        </div>
                        <div className="rec-user-info left">
                            <div className="M15_42 user-name">{reviews && reviews.firstname}</div>
                            <div className="userdesc R13_9e">{reviews.childkey}</div>
                            <div className="rec-star-rev-block" >
                                {items[index]}
                            </div>
                        </div>
                        <div className="review-time right R13_9e">{reviews && reviews.daysago} ago</div>
                    </div>

                    <div className="review-rec-desc R14_75 more" data-id={`review_${index}`} id={`review_${index}`}><span>{reviews && reviews.reviewDescription}</span></div>
                    <div className="readmore R13_link" onClick={(e) => actions.seeMoreClick(e, '40px', "reviews", isApp)}></div>
                    {reviews && reviews.uploadedRecUrl &&
                        <div className="rev-rec-pic">
                            <img src={reviews.uploadedRecUrl} />
                        </div>
                    }
                    <div className="hrline"></div>
                    <div className="meal-card-actions">
                        <div className="card-views social-actions like-algn">
                            {reviews && reviews.isLike > 0 ?
                                (<span>
                                    <span data-icon-font="&#xe009;" className="icon R13_61 active like-icon"></span>
                                    <span className="like-count R13_61">
                                        <span className="total_likes">
                                            {reviews.likecount}
                                        </span>
                                        <span className="activity-txt">  Likes</span>
                                    </span>
                                </span>
                                ) :
                                (
                                    <span>
                                        <span data-icon-font="&#xe009;" className="icon R13_61 like-icon dev_rv_lk" onClick={(e) => eleRef.likeArticle(reviews.id)}>
                                        </span>
                                        <span className="like-count R13_61">
                                            <span className="total_likes">
                                                {reviews.likecount}
                                            </span>
                                            <span className="activity-txt">  Likes</span>
                                        </span>
                                    </span>
                                )}
                        </div>
                        {/* <div className="card-share left social-actions">
                            <div className="R13_61 left share-icon" onClick={(e) => actions.shareOn(e, index, isApp, "", "","review","")}>
                                <div className="fb-icon left">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png" />
                                </div>
                                <div data-icon-font="" className="whtapp-icon left"></div>
                                <div className="left share-txt R12_16">Share</div>
                            </div>
                            <ShareOptions eleRef={eleRef} index={index} />
                        </div> */}
                        { reviews.firstname != userName ?
                        <div className="m-abuse-main right">
                            {reviews && reviews.isAbuse > 0 ?
                                (
                                    <div className="abuseicon right active" data-icon-font=""></div>
                                ) :
                                (<div>
                                    <div className="abuseicon right" data-icon-font="" onClick={(e) => { eleRef.abusePopup(e) }}></div>
                                    <div className="m-abuse-popup" id="dev_rpt_abuse" onClick={(e) => { eleRef.isAbuseSet(reviews.id) }}>Report Abuse</div>
                                </div>
                                )

                            }
                        </div>:
                         <div className="m-abuse-main right"></div>
                        }
                    </div>
                </div>
            )}
        </div>
    )
}
